var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "manage-goods-container" },
    [
      _vm._m(0),
      _c("StatusChangeBar", { on: { statusChange: _vm.statusChange } }),
      _c("SearchBar", {
        on: { searchClick: _vm.searchClick, resetClick: _vm.resetClick }
      }),
      _c(
        "div",
        { staticClass: "table-box" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.isLoading,
                  expression: "isLoading"
                }
              ],
              staticStyle: { width: "100%", "margin-bottom": "20px" },
              attrs: {
                data: _vm.spuList,
                "row-key": "uniqueKey",
                border: "",
                "tree-props": {
                  children: "children",
                  hasChildren: "hasChildren"
                }
              }
            },
            [
              _vm._v("\n      >\n      "),
              _c("el-table-column", {
                attrs: { type: "index", width: "50" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.isSpu
                          ? [
                              _c("el-checkbox", {
                                on: { change: _vm.oneSpuCheckedChange },
                                model: {
                                  value: scope.row.checked,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "checked", $$v)
                                  },
                                  expression: "scope.row.checked"
                                }
                              })
                            ]
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "name",
                  label: "商品名称",
                  "min-width": "20%"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "商品图片",
                  "min-width": "15%"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("el-image", {
                          staticStyle: { width: "50px", height: "50px" },
                          attrs: { src: scope.row.picUrl, fit: "cover" }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "价格(元)", "min-width": "10%" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.specType === 0
                          ? [
                              _vm._v(
                                _vm._s(
                                  scope.row.children &&
                                    scope.row.children[0].marketPriceStr
                                )
                              )
                            ]
                          : [
                              _c("div", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.marketPriceStr) +
                                    "\n            "
                                )
                              ])
                            ]
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "单位", "min-width": "10%" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.specType === 0
                          ? [
                              _vm._v(
                                _vm._s(
                                  scope.row.children &&
                                    scope.row.children[0].unitName
                                )
                              )
                            ]
                          : [
                              _c("div", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.unitName) +
                                    "\n            "
                                )
                              ])
                            ]
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "库存", "min-width": "20%" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.isSpu
                          ? _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "top",
                                  width: "193",
                                  trigger: "click"
                                },
                                model: {
                                  value: scope.row.popoverVisible,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "popoverVisible", $$v)
                                  },
                                  expression: "scope.row.popoverVisible"
                                }
                              },
                              [
                                scope.row.isSpu
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "flex items-center",
                                        attrs: { slot: "reference" },
                                        slot: "reference"
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.currQuantity))
                                        ]),
                                        _c("i", {
                                          staticClass: "el-icon-edit mar5-l"
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _c("div", [
                                  _c("h4", [_vm._v("修改库存")]),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "margin-top": "7px"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          size: "mini",
                                          type: "number",
                                          min: 0,
                                          max: 99999,
                                          oninput:
                                            "if(value){value=value.replace(/[^\\d]/g,'')} if(value<=0){value=''} if(value>99999){value=99999}",
                                          placeholder: "商品库存"
                                        },
                                        on: {
                                          input: _vm.batchStockInput,
                                          change: _vm.batchStockChange
                                        },
                                        model: {
                                          value: scope.row.currQuantity,
                                          callback: function($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "currQuantity",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.currQuantity"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "mar10-t" },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { size: "mini" },
                                          on: {
                                            click: function($event) {
                                              return _vm.batchStockCancle(
                                                scope.row.id
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("取消")]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "primary"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.batchStockSure(
                                                scope.row
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("确定")]
                                      )
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.currQuantity))
                              ])
                            ]
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "分类", "min-width": "20%" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.isSpu
                          ? [
                              scope.row.goodsType
                                ? _c("span", [
                                    _vm._v(_vm._s(scope.row.goodsType))
                                  ])
                                : _vm._e(),
                              scope.row.goodsType
                                ? _c("i", {
                                    staticClass: "el-icon-edit mar5-l",
                                    on: {
                                      click: function($event) {
                                        return _vm.showCategroyDialogClick(
                                          scope.row
                                        )
                                      }
                                    }
                                  })
                                : _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function($event) {
                                          return _vm.showCategroyDialogClick(
                                            scope.row
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("+添加")]
                                  )
                            ]
                          : [
                              _c("div", { staticClass: "nodata_line_color" }, [
                                _vm._v("——")
                              ])
                            ]
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "状态", "min-width": "10%" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.isSpu
                          ? [
                              scope.row.status == 1
                                ? _c("span", [_vm._v(" 已保存 ")])
                                : _vm._e(),
                              scope.row.status == 2
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "#1890ff" } },
                                    [_vm._v(" 待审核 ")]
                                  )
                                : _vm._e(),
                              scope.row.status == 3
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "#ff7f27" } },
                                    [_vm._v(" 驳回 ")]
                                  )
                                : _vm._e(),
                              scope.row.status == 9
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "#ff7f27" } },
                                    [_vm._v(" 店铺驳回 ")]
                                  )
                                : _vm._e(),
                              scope.row.status == 5
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "#188506" } },
                                    [_vm._v(" 出售中 ")]
                                  )
                                : _vm._e(),
                              scope.row.status == 6
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v(" 已下架 ")]
                                  )
                                : _vm._e(),
                              scope.row.status == 8
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v(" 强制下架 ")]
                                  )
                                : _vm._e()
                            ]
                          : [
                              _c("div", { staticClass: "nodata_line_color" }, [
                                _vm._v("——")
                              ])
                            ]
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "300" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.isSpu
                          ? [
                              scope.row.status != 2 && scope.row.status != 3
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini" },
                                      on: {
                                        click: function($event) {
                                          return _vm.editSpuClick(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("编辑")]
                                  )
                                : _vm._e(),
                              scope.row.status == 5
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini" },
                                      on: {
                                        click: function($event) {
                                          return _vm.oneXiaJia(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("下架")]
                                  )
                                : _vm._e(),
                              scope.row.status == 1 || scope.row.status == 6
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini" },
                                      on: {
                                        click: function($event) {
                                          return _vm.oneShangJia(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("上架")]
                                  )
                                : _vm._e(),
                              scope.row.status == 2
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini" },
                                      on: {
                                        click: function($event) {
                                          return _vm.cancelAudit(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("取消审核")]
                                  )
                                : _vm._e(),
                              scope.row.status == 3
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini" },
                                      on: {
                                        click: function($event) {
                                          return _vm.editSpuClick(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("重新编辑")]
                                  )
                                : _vm._e(),
                              scope.row.status == 1 ||
                              scope.row.status == 3 ||
                              scope.row.status == 6 ||
                              scope.row.status == 8
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini" },
                                      on: {
                                        click: function($event) {
                                          return _vm.goodsDeleteClick(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("删除")]
                                  )
                                : _vm._e(),
                              scope.row.status != 3
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini" },
                                      on: {
                                        click: function($event) {
                                          return _vm.lookQRCodeClick(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("二维码")]
                                  )
                                : _vm._e()
                            ]
                          : [
                              scope.row.status != 3
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini" },
                                      on: {
                                        click: function($event) {
                                          return _vm.lookQRCodeClick(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("二维码")]
                                  )
                                : _vm._e()
                            ]
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "bottom-handle-box" },
        [
          _c(
            "el-checkbox",
            {
              model: {
                value: _vm.selectAll,
                callback: function($$v) {
                  _vm.selectAll = $$v
                },
                expression: "selectAll"
              }
            },
            [_vm._v("全选")]
          ),
          _c("el-divider", { attrs: { direction: "vertical" } }),
          _c(
            "el-button",
            {
              staticStyle: { color: "#606266" },
              attrs: { type: "text" },
              on: { click: _vm.batchShangJia }
            },
            [_vm._v("批量上架")]
          ),
          _c(
            "el-button",
            {
              staticStyle: { color: "#606266" },
              attrs: { type: "text" },
              on: { click: _vm.batchXiaJia }
            },
            [_vm._v("批量下架")]
          ),
          _c(
            "el-button",
            {
              staticStyle: { color: "#606266" },
              attrs: { type: "text" },
              on: { click: _vm.batchaddCate }
            },
            [_vm._v("批量分类")]
          ),
          _c(
            "el-button",
            {
              staticStyle: { color: "#606266" },
              attrs: { type: "text" },
              on: { click: _vm.batchDeleteClassify }
            },
            [_vm._v("移除分类")]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-box" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "prev, pager, next",
              total: _vm.total,
              "current-page": _vm.currentPage
            },
            on: { "current-change": _vm.handleCurrentChange }
          })
        ],
        1
      ),
      _vm.showCategoryDialog
        ? _c("CategoryDialog", {
            ref: "categoryDialogref",
            attrs: { showCategoryDialog: _vm.showCategoryDialog },
            on: {
              "update:showCategoryDialog": function($event) {
                _vm.showCategoryDialog = $event
              },
              "update:show-category-dialog": function($event) {
                _vm.showCategoryDialog = $event
              },
              reloadspuList: _vm.reloadspuList
            }
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "二维码",
            visible: _vm.showQRCodeDialog,
            width: "260px"
          },
          on: {
            "update:visible": function($event) {
              _vm.showQRCodeDialog = $event
            }
          }
        },
        [
          _c("el-row", { attrs: { type: "flex", justify: "center" } }, [
            _c("div", { staticClass: "qrCode-box" }, [
              _c("canvas", { ref: "qrCodeCanvas" }),
              _c(
                "div",
                { staticClass: "img-box" },
                [
                  _c("el-image", {
                    staticStyle: { width: "20px", height: "20px" },
                    attrs: { src: _vm.showQRDialogImgUrl, fit: "cover" }
                  })
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("h2", [_vm._v("套餐管理")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }